import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Slider from 'rc-slider';
import { useRef } from 'react';
import classNames from 'classnames';
import styles from './NumericRange.module.scss';
const NumericRange = ({ options, values, onChange, onSubmit = () => null, step = 1, sliderClasses, displayValue = '', headline, label = '', pushable = true, allowCross = false, }) => {
    /** onAfterChange from rc-slider is triggred twice with every click, this bug still not yet fixed
     * Link to the issue : https://github.com/react-component/slider/issues/492
     * It duplicates the data in the datalayer tracking
     * This is a workaround to avoid triggring the submit function twice
     */
    const previousRangeRef = useRef();
    const onAfterChange = (range) => {
        if (range !== previousRangeRef.current) {
            previousRangeRef.current = range;
            onSubmit(range);
        }
    };
    const valueArray = values.length === 2
        ? [values[0] || options[0], values[1] || options[1]]
        : [values[0] || options[0]];
    return (_jsxs(_Fragment, { children: [headline || (_jsxs("div", { className: styles.elementHeadline, children: [label, _jsx("span", { className: styles.elementValues, children: displayValue })] })), _jsx(Slider, { range: valueArray.length >= 2, min: options[0], max: options[1], step: step, startPoint: 0, value: valueArray, onAfterChange: onAfterChange, onChange: onChange, allowCross: allowCross, className: classNames(styles.inputRange, sliderClasses), pushable: pushable })] }));
};
export { NumericRange };
